(function () {
  'use strict';

  var id = "program";
  angular.module('wsLrs.services').factory(id + ".PageText", ['CardText', function (CardText) {
    var defaultCardTextTemplate = {
      "program": {
        "tags": ['resultCount', 'resultType'],
        "resultSectionHeader": "{{resultCount}} {{resultType}}",
        "detail": {
          "tags": ['detailType', 'totalPeople', 'peopleComplete', 'peopleInProgress', 'peopleNotStarted', 'averageElapsedToCompleteSeconds', 'resultCount', 'resultType'],
          // people in program section
          "peopleInProgram": "People in {{detailType}}",
          "totalPeople": "{{totalPeople}}",
          "peopleCurrentlyEnrolled": "People currently enrolled, including those who have not started, are making progress, or have completed the program.",
          // program completions section
          "programCompletions": "{{detailType}} completions",
          "peopleComplete": "{{peopleComplete}}",
          "peopleCompletedThisProgram": "People completed this program.",
          // program in progress section
          "programInProgress": "{{detailType}} in progress",
          "peopleInProgress": "{{peopleInProgress}}",
          "peopleInProgressThisProgram": "People making progress in this program.",
          //program not started section
          "programNotStarted": "{{detailType}} not started",
          "peopleNotStarted": "{{peopleNotStarted}}",
          "peopleNotStartedThisProgram": "People not started this program.",
          // average time section
          "averageTimeToComplete": "Average time to complete {{detailType}}",
          "averageElapsedToCompleteSeconds": "{{averageElapsedToCompleteSeconds}}",
          "timeToCompleteAllRequirements": "Time to complete all requirements of this program.",
          // program milestones section
          "programMilestones": "Program milestones",
          "whatPercentageOfEnrolled": "What percentage of enrolled people have completed each milestone?",
          "whatPercentageOfEnrolled_ordered": "Where are currently enrolled people with regard to each program milestone?",
          "lastMilestoneProgress": "Last milestone progress",
          // group section
          "groupSectionHeader": "{{resultCount}} {{resultType}}"
        },
        "groupDetail": {
          "tags": ["groupName", "avgProgressPct", "programName"],
          "noPeopleHaveStartedProgram": "{{groupName}}: No people in this group have started {{programName}}.",
          "allPeopleHaveStartedProgram": "{{groupName}}: All people in this group have finished {{programName}}.",
          "peopleCompletedPercentage": "{{groupName}}: People have completed {{avgProgressPct}}% of {{programName}}."
        },
        "milestoneDetail": {
          "tags": ["detailType", "milestoneName"],
          "peopleInMilestone": "People in {{detailType}}",
          "milestoneCompletions": "{{detailType}} completions",
          "milestoneInProgress": "{{detailType}} in progress",
          "milestoneNotStarted": "{{detailType}} not started",
          "peopleCompletedThisMilestone": "People completed this milestone.",
          "peopleNotStartedThisMilestone": "People not started this milestone.",
          "peopleInProgressThisMilestone": "People making progress in this milestone.",
          "milestoneActivities": "{{milestoneName}} milestones",
          "whatPercentageOfEnrolled": "What percentage of enrolled people have completed each milestone activity?",
          "whatPercentageOfEnrolled_ordered": "Where are currently enrolled people with regard to each milestone activity?"
        },
        "personDetail": {
          "tags": ['person', 'learningPath', 'percentCompleted', 'resultCount', 'resultType'],
          "personHasNotStartedProgram": "{{person}} hasn't started the {{learningPath}} program.",
          "personHasFinishedProgram": "{{person}} has finished the {{learningPath}} program.",
          "personCompletedPercentage": "{{person}} has completed {{percentCompleted}}% of the {{learningPath}} program.",
          "milestoneTableMilestoneColumn": "Milestone",
          "lastMilestoneProgress": "Last milestone progress",
          "milestoneSectionHeader": "{{resultCount}} {{resultType}}"
        }
      }
    };
    var instantiatePageText = function instantiatePageText(cardTextTemplate, cardConfig) {
      var cardText = CardText.bind(cardTextTemplate, cardConfig);
      var pageText = {
        render: function render(path, context) {
          return cardText.render(path, context);
        },
        lift: function lift(func, f) {
          for (var _len = arguments.length, params = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
            params[_key - 2] = arguments[_key];
          }
          pageText[func] = function () {
            for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }
            return f.apply(pageText, params.concat(args));
          };
          return pageText;
        }
      };
      return pageText;
    };
    var bind = function bind(_ref) {
      var _ref$cardTextTemplate = _ref.cardTextTemplate,
        cardTextTemplate = _ref$cardTextTemplate === void 0 ? defaultCardTextTemplate : _ref$cardTextTemplate,
        cardConfig = _ref.cardConfig;
      return instantiatePageText(cardTextTemplate, cardConfig).lift("resultSectionHeader", function (count, singular, plural) {
        if (typeof plural === 'undefined') {
          return this.resultSectionHeader(count, singular, singular + 's');
        }
        return this.render('program.resultSectionHeader', {
          resultCount: count,
          resultType: count === 1 ? singular : plural
        });
      });
    };
    return {
      defaultCardTextTemplate: defaultCardTextTemplate,
      bind: bind
    };
  }]);
})();
